import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Rocket, Code2, Handshake } from "lucide-react";
import { SectionHead } from "@/components/Blocks";
import { Stagger, itemVariants, Tilt } from "@/components/motion";

const CARDS = [
  { n: "01", icon: Rocket, title: "Build our ventures", text: "We create and grow independent software products designed to solve real problems for founders, developers, and modern businesses.", cta: "Explore Our Ventures", to: "/ventures", glow: "rgba(23,182,244,0.18)" },
  { n: "02", icon: Code2, title: "Build your product", text: "We work with founders to shape, design, engineer, and launch web applications, SaaS platforms, and AI-powered products.", cta: "Build With Us", to: "/services", glow: "rgba(23,107,255,0.22)" },
  { n: "03", icon: Handshake, title: "Build together", text: "We selectively partner with ambitious founders to explore, validate, and co-build promising business opportunities.", cta: "Explore Partnerships", to: "/venture-partnerships", glow: "rgba(249,138,23,0.16)" },
];

export default function WhatWeDo() {
  return (
    <section className="relative py-24 sm:py-32" data-testid="what-we-do-section">
      <div className="wrap">
        <SectionHead eyebrow="What we do" title={["One team.", "Multiple ways to build."]}
          intro="From your first product idea to your next stage of growth, we help turn technology into a business advantage." />
        <Stagger className="mt-16 grid gap-5 md:grid-cols-3">
          {CARDS.map((c) => (
            <motion.div key={c.n} variants={itemVariants} className="h-full">
              <Tilt className="h-full" max={3}>
                <Link to={c.to} data-testid={`what-card-${c.n}`}
                  className="group relative flex h-full min-h-[380px] flex-col overflow-hidden rounded-3xl border border-si-line bg-si-surface/60 p-8 transition-[border-color,transform,box-shadow] duration-300 hover:-translate-y-1 hover:border-si-cyan/50 hover:shadow-[0_30px_80px_-30px_rgba(23,182,244,0.45)]">
                  <div className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                    style={{ background: `radial-gradient(400px circle at var(--mx,50%) var(--my,0%), ${c.glow}, transparent 60%)` }} />
                  <div className="relative flex items-start justify-between">
                    <span className="grid h-14 w-14 place-items-center rounded-2xl border border-si-line bg-si-bg/60 text-si-cyan transition-colors group-hover:border-si-cyan/50"><c.icon className="h-6 w-6" /></span>
                    <span className="font-mono text-sm text-si-muted">{c.n}</span>
                  </div>
                  <h3 className="h-card relative mt-20">{c.title}</h3>
                  <p className="relative mt-4 flex-1 text-base leading-relaxed text-si-muted">{c.text}</p>
                  <span className="relative mt-8 inline-flex items-center gap-2 text-[15px] font-semibold text-si-cyan">
                    {c.cta}<ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1.5" />
                  </span>
                </Link>
              </Tilt>
            </motion.div>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
